import { Button, Form, InputNumber, Modal } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import React, { FC, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { patchLocationForSupplier } from '../../thunks/locations_thunks';

const FORM_NAME = 'tax-rate-form';

const TaxRateModal: FC<any> = ({ onCancel, record, update, saving }): React.ReactElement => {
	const [form] = useForm();

	const onSubmit = useCallback(
		(values) => {
			update(record.id, {
				taxRate: `${values.taxRate}`,
			}).then(() => onCancel());
		},
		[record.id, onCancel, update]
	);

	const title = useMemo(() => {
		return `Update Tax Rate for ${record.name}`;
	}, [record.name]);

	return (
		<Modal
			visible={true}
			width={600}
			title={title}
			closable
			onCancel={onCancel}
			forceRender
			footer={[
				<Button onClick={onCancel} size="large">
					Cancel
				</Button>,
				<Button
					type="primary"
					size="large"
					style={{ marginLeft: '16px' }}
					key="submit"
					htmlType="submit"
					form={FORM_NAME}
					loading={saving}
				>
					Update
				</Button>,
			]}
		>
			<Form
				form={form}
				id={FORM_NAME}
				layout="vertical"
				requiredMark={false}
				initialValues={{ taxRate: nullSafeGet('taxRate', record) }}
				onFinish={onSubmit}
			>
				<Form.Item
					name="taxRate"
					label="Tax Rate"
					rules={[
						{
							required: true,
							message: `Please enter tax rate`,
						},
						{
							type: 'number',
							min: 0,
							max: 100,
							message: 'Please enter rate in percentage not exceeding 100',
						},
					]}
				>
					<InputNumber style={{ width: '100%' }} addonAfter="%" />
				</Form.Item>
			</Form>
		</Modal>
	);
};

const mapStateToProps = (state) => ({
	saving: state.locations.creating || state.locations.updating,
});

const mapDispatchToProps = (dispatch) => ({
	update: (id, data) => dispatch(patchLocationForSupplier(id, data)),
});

export default withRouter<any, any>(connect(mapStateToProps, mapDispatchToProps)(TaxRateModal));
